<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group>
            <b-form-radio 
              v-model="filtro.filtroPeriodo" 
              name="filtroPeriodoOption" 
              :value="Boolean(true)"
              stacked>Filtrar por período</b-form-radio>

            <b-collapse 
                id="filtroOpcionPeriodo" 
                class="mt-2" 
                v-model="showOpcionesPeriodo">

              <b-form-group
                label="Desde"
                label-for="fechaDesde"
                :label-cols="2"
                horizontal>
                <b-form-input 
                  id="fechaDesde"
                  v-model= "filtro.fechaDesde" 
                  type="date">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Hasta"
                label-for="fechaHasta"
                :label-cols="2"
                horizontal>
                <b-form-input 
                  id="fechaHasta" 
                  v-model= "filtro.fechaHasta" 
                  type="date">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Cliente"
                label-for="cliente"
                :label-cols="labelCols"
                horizontal>
                <b-input-group>
                  <b-input-group-append 
                      class="filter-search-icons"
                      v-if="!filtro.filtroBrief"
                      @click="seleccionarCliente">
                    <b-input-group-text>
                      <i :class="{ 'fa fa-search': !filtro.cliente,
                                    'fa fa-remove': filtro.cliente  }"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <b-form-input 
                    id="cliente"
                    :value="clienteNombre"
                    readonly
                    type="text"/>
                </b-input-group>
              </b-form-group>

              <app-usuario
                label="Responsable"
                :nombre="usuarioNombre"
                :lista="usuariosList"
                :label-cols="labelCols"
                labelOption="Todos los usuarios"
                :nullDisabled="false"
                @updated="usuarioActualizado">
              </app-usuario>  

              <app-estado
                label="Estado"
                :nombre="estadoNombre"
                :lista="estadosList"
                :label-cols="labelCols"
                labelOption="Todos los estados"
                :nullDisabled="false"
                @updated="estadoActualizado">
              </app-estado>  

              <app-prioridad
                label="Prioridad"
                :nombre="prioridadNombre"
                :lista="prioridadesList"
                :label-cols="labelCols"
                labelOption="Todas las prioridades"
                :nullDisabled="false"
                @updated="prioridadActualizada">
              </app-prioridad>  
            </b-collapse>

            <b-form-radio 
              v-model="filtro.filtroBrief" 
              name="filtroNumeroOption" 
              :value="Boolean(true)"
              stacked>Filtrar por Brief</b-form-radio>

            <b-collapse 
                id="filtroOpcionBrief" 
                class="mt-2" 
                v-model="showOpcionesBrief">

              <b-form-group
                label="Nro. Brief"
                label-for="briefId"
                :label-cols="2"
                horizontal>
                <b-form-input 
                  id="briefId" 
                  v-model="filtro.briefId" 
                  type="text">
                </b-form-input>
              </b-form-group>
            </b-collapse>

            <b-form-radio 
              v-model="filtro.filtroPresupuesto" 
              name="filtroPresupuestoOption" 
              :value="Boolean(true)"
              stacked>Filtrar por Presupuesto Interno</b-form-radio>

            <b-collapse 
                id="filtroOpcionPresupuesto" 
                class="mt-2" 
                v-model="showOpcionesPresupuesto">

              <b-form-group
                label="Nro. Presupuesto"
                label-for="presupuestoNumero"
                :label-cols="2"
                horizontal>
                <b-form-input 
                  id="presupuestoNumero" 
                  v-model="filtro.presupuestoNumero" 
                  type="text">
                </b-form-input>
              </b-form-group>
            </b-collapse>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import Usuario from '../shared/abmSelect.vue';
import Estado from '../shared/abmSelect.vue';
import Prioridad from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  components: {
    appSearchCliente: SearchCliente,
    appUsuario: Usuario,
    appEstado: Estado,
    appPrioridad: Prioridad
  },
  props: {
    filtroPeriodo: {
      type: Boolean,
      default: true,
    },
    filtroBrief: {
      type: Boolean,
      default: false,
    },
    filtroPresupuesto: {
      type: Boolean,
      default: false,
    },
    fechaDesde: {
      type: Date,
      /*default: ''*/
    },
    fechaHasta: {
      type: Date,
      /*default: ''*/
    },
    cliente: {
      type: Object,
      default: null
    },
    estado: {
      type: Object,
      default: null
    },
    prioridad: {
      type: Object,
      default: null
    },
    usuario: {
      type: Object,
      default: null
    },
    briefId: {
      type: Number,
      default: 0
    },
    presupuestoNumero: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      filtro: {
        filtroPeriodo: true,
        filtroBrief: false,      
        filtroPresupuesto: false,
        fechaDesde: '',
        fechaHasta: '',
        cliente: null,
        estado: null,
        prioridad: null,
        usuario: null,
        briefId: 0,
        presupuestoNumero: 0,
      },
      showOpcionesFiltro: Boolean(false),

      showOpcionesPeriodo: true,
      showOpcionesBrief: false,
      showOpcionesPresupuesto: false,
      labelCols: 2,

      usuarios: [],
      usuariosList: [],
      loadingUsuarios: false,
      estados: [],
      estadosList: [],
      loadingEstados: false,
      prioridades: [],
      prioridadesList: [],
      loadingPrioridades: false
    }
  },
  created() {
      this.filtro.filtroPeriodo = this.filtroPeriodo;
      this.filtro.filtroBrief = this.filtroBrief;
      this.filtro.filtroPresupuesto = this.filtroPresupuesto;
      this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
      this.filtro.cliente = this.cliente;
      this.filtro.estado = this.estado;
      this.filtro.prioridad = this.prioridad;
      this.filtro.usuario = this.usuario;
      this.filtro.briefId = this.briefId; 
      this.filtro.presupuestoNumero = this.presupuestoNumero;

      this.getDatosAdicionales();
  },
  computed: {
    'clienteNombre': function() {
      return this.filtro.cliente? this.filtro.cliente.nombre.trim() : '';
    },
    'estadoNombre': function() {
      return this.filtro.estado? this.filtro.estado.nombre.trim() : null;
    },
    'prioridadNombre': function() {
      return this.filtro.prioridad? this.filtro.prioridad.nombre.trim() : null;
    },
    'usuarioNombre': function() {
      return this.filtro.usuario? this.filtro.usuario.nombreCompleto.trim() : null;
    },
  },     
  methods: {
    getDatosAdicionales() {
      this.loadingUsuarios = true;
      this.$store.dispatch('usuarios/getUsuariosAsignarBrief')
        .then(() => {
          this.usuarios = this.$store.getters['usuarios/list'];
          this.usuariosList = this.$store.getters['usuarios/selectList'];
          this.loadingUsuarios = false;
        })

      this.loadingEstados = true;
      this.$store.dispatch('briefsTareasEstados/getList')
        .then(() => {
          this.estados = this.$store.getters['briefsTareasEstados/list'];
          this.estadosList = this.$store.getters['briefsTareasEstados/selectList'];
          this.loadingEstados = false;
        })
      
      this.loadingPrioridades = true;
      this.$store.dispatch('prioridades/getList')
        .then(() => {
          this.prioridades = this.$store.getters['prioridades/list'];
          this.prioridadesList = this.$store.getters['prioridades/selectList'];
          this.loadingPrioridades = false;
        })

    },
    filtrar() {
      let filtrar = true;

      if ((/true/i).test(this.filtro.filtroBrief)) {
        let briefId = parseInt(this.filtro.briefId);

        if (briefId == 0) {
          filtrar = false;
        }
      }

      if ((/true/i).test(this.filtro.filtroPresupuesto)) {
        let presupuestoNumero = parseInt(this.filtro.presupuestoNumero);

        if (presupuestoNumero == 0) {
          filtrar = false;
        }
      }

      if (filtrar) {
        this.$emit('filtrar', this.filtro);
      }
    },
    limpiarFiltro() {
      this.filtro.cliente = null;
      this.filtro.estado = null;
      this.filtro.prioridad = null;
      this.filtro.usuario = null;
      this.filtro.briefId = 0; 
      this.filtro.presupuestoNumero = 0;
    },
    seleccionarCliente() {
      if (this.filtro.cliente) {
        this.filtro.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.filtro.cliente = cliente;
      this.$refs.searchClienteModal.hide();
    },
    usuarioActualizado(usuarioNombre) {
      if (!this.loadingUsuarios) {
        this.filtro.usuario= null;

        if (usuarioNombre) {
          this.filtro.usuario = this.getSelectedByNombreCompleto(this.usuarios, usuarioNombre);
        }
      }
    },
    getSelectedByNombreCompleto (list, nombre) {
        var selected = {};
        if (nombre) {
          for ( let key in list ){
            const element = list[key];
            if (element.nombreCompleto.trim() == nombre.trim() ){
              selected = element;
            }
          }
        }
        return selected;
    },
    estadoActualizado(estadoNombre) {
      if (!this.loadingEstados) {
        this.filtro.estado= null;

        if (estadoNombre) {
          this.filtro.estado = this.getSelected(this.estados, estadoNombre);
        }
      }
    },
    prioridadActualizada(prioridadNombre) {
      if (!this.loadingPrioridades) {
        this.filtro.prioridad= null;

        if (prioridadNombre) {
          this.filtro.prioridad = this.getSelected(this.prioridades, prioridadNombre);
        }
      }
    },
  },
  watch: {
    'filtro.filtroPeriodo' : function(newVal, oldVal) {
      if (newVal) {
        this.showOpcionesPeriodo = true;
        
        this.filtro.filtroBrief = false;
        this.filtro.filtroPresupuesto = false;
      } else {
        this.showOpcionesPeriodo = false;
      }
    },
    'filtro.filtroBrief' : function(newVal, oldVal) {
      if (newVal) {
        this.showOpcionesBrief = true;

        this.filtro.filtroPeriodo = false;
        this.filtro.filtroPresupuesto = false;
      } else {
        this.showOpcionesBrief = false;
      }
    },
    'filtro.filtroPresupuesto' : function(newVal, oldVal) {
      if (newVal) {
        this.showOpcionesPresupuesto = true;

        this.filtro.filtroPeriodo = false;
        this.filtro.filtroBrief = false;
      } else {
        this.showOpcionesPresupuesto = false;
      }
    },
  }    

}
</script>

<style>
</style>
